var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgIconLanguageBangla = function SvgIconLanguageBangla(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    x: 1,
    y: 1,
    fill: "#FFF",
    stroke: "#EC1D39",
    strokeWidth: 2,
    rx: 13
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB1E3B",
    d: "M35.12 27.28H12.8v-6.54h36.54v6.54h-6v27.48l2.94 1.74-5.34 5.46L16.1 47.5v-6.66c2.64-2.82 9.96-8.88 19.02-11.34v-2.22zm0 10.08c-4.92 1.86-9.18 5.1-10.5 6.6l10.98 6.36h.24c-.48-1.5-.72-5.7-.72-9.36v-3.6zM53.3 15.22v-.6h8.04v6.12h6v6.54h-6V61h-8.4V34.3c0-5.88-1.98-7.02-5.76-7.02h-.24v-6.54h2.46c2.76 0 4.2 1.2 4.92 2.1h.42c-.84-2.22-1.44-4.8-1.44-7.62z"
  }))));
};
export default SvgIconLanguageBangla;